import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { timer } from "rxjs";
import { LocalstorageService } from "../../../shared";
import { DataService_BusTrackerBusOverview } from "./shared/data.service";

@Component({
	selector: "app-bus-overview-table",
	templateUrl: "./bus-overview-table.component.html",
	styleUrls: ["./bus-overview-table.component.css"],
})
export class BusOverviewTableComponent implements OnInit {
	constructor(private busService: DataService_BusTrackerBusOverview, private dialogService: DialogService, private localService: LocalstorageService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadPreferences();
	}

	ngOnDestory() {
		this.Refresher.unsubscribe();
		this.UpdatePreferences();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	PreferenceLoading: any = true;

	RefreshSeconds: number = 60;
	MinimumRefreshSeconds: number = 10;
	Refresher: any;
	RefreshTimer: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBus: any;
	lstBus: any = [];

	//Filter lists
	lstBusRouteTypeDesc: any = [];
	lstSeverityDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "BusNbr", header: "Bus" },
		{ field: "BusDesc", header: "Description" },
		{ field: "BusRouteNbr", header: "Route" },
		{ field: "BusRouteTypeDesc", header: "Route Type" },
		{ field: "DriverName", header: "Driver" },
		{ field: "StudentCount", header: "Students" },
		{ field: "UnassignedCount", header: "Unassigned Students" },
		{ field: "LastUpdatedDesc", header: "Last Updated" },
		// { field: 'AlertDesc', header: 'AlertDesc' },
		// { field: 'SeverityDesc', header: 'SeverityDesc' }
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPreferences() {
		this.PreferenceLoading = true;

		var BT_Overview = this.localService.getItem("BT_Overview");

		if (BT_Overview != undefined) {
			this.RefreshSeconds = BT_Overview.RefreshSeconds;
		}

		this.PreferenceLoading = false;

		this.onRefresh();
	}

	loadBus() {
		this.errorMessage = "";

		if (this.loading == true) {
			return;
		}

		this.loading = true;

		var result = this.busService.BusOverviewFullInfoSelectList();
		result.subscribe(
			(response) => {
				if (this.lstBus.length == 0) {
					this.lstBus = response;
				} else {
					var lstOpen: any = this.lstBus.filter((bus) => bus.DisplayDetails == true);
					var data: any = response;

					for (var z = 0; z < lstOpen.length; z++) {
						var nextOpen = lstOpen[z];

						for (var x = 0; x < data.length; x++) {
							var nextData = data[x];

							if (nextOpen.BusID == nextData.BusID) {
								nextData.DisplayDetails = true;
								break;
							}
						}
					}

					this.lstBus = data;
				}

				//Load Data Filter Lists
				this.lstBusRouteTypeDesc = Array.from(new Set(this.lstBus.map((item: any) => item.BusRouteTypeDesc))).sort();
				this.lstSeverityDesc = Array.from(new Set(this.lstBus.map((item: any) => item.SeverityDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		if (Number(this.RefreshSeconds) < Number(this.MinimumRefreshSeconds)) {
			this.RefreshSeconds = this.MinimumRefreshSeconds;
		}

		this.RefreshTimer = timer(
			Number(this.RefreshSeconds) < Number(this.MinimumRefreshSeconds) ? this.MinimumRefreshSeconds : this.RefreshSeconds * 1000,
			Number(this.RefreshSeconds) < Number(this.MinimumRefreshSeconds) ? this.MinimumRefreshSeconds : this.RefreshSeconds * 1000
		);

		try {
			this.Refresher.unsubscribe();
		} catch (e) {
			e.toString();
		}

		this.Refresher = this.RefreshTimer.subscribe((val) => {
			this.onRefresh();
		});

		this.loadBus();
	}

	//Custom Button Methods
	onExpand(Bus) {
		Bus.DisplayDetails = !Bus.DisplayDetails;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onRefreshSecondsChange(val) {
		this.RefreshSeconds = val;

		if (Number(this.RefreshSeconds) < Number(this.MinimumRefreshSeconds)) {
			this.RefreshSeconds = this.MinimumRefreshSeconds;
		}

		this.UpdatePreferences();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedBus = val.data;
	}
	onRowUnselect(val) {
		this.SelectedBus = null;
	}
	onRowDblClick(Bus) {
		this.SelectedBus = Bus;
		this.onExpand(Bus);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdatePreferences() {
		if (Number(this.RefreshSeconds) < Number(this.MinimumRefreshSeconds)) {
			this.RefreshSeconds = this.MinimumRefreshSeconds;
		}

		let BT_Overview: any = {
			RefreshSeconds: this.RefreshSeconds,
		};

		this.localService.setItem("BT_Overview", BT_Overview);
	}

	IsLoading() {
		return this.PreferenceLoading == true || this.loading == true;
	}

	////////////////////////////////////////////
}
